<template>
  <div id="contact">
    <section class="footer-contact-area section_padding_100 clearfix saas-contact-us">
      <div class="container">
        <div class="justify-content-center row">
          <div class="col-sm-12 col-md" data-aos="fade-up" data-aos-duration="1200">
            <h2 class="contact-title"> Let's Talk</h2>
            <p class="contact-p">If you are an enterprise, have a unique offer or want to share some inspirational thoughts - we are here to listen</p>
            <p class="contact-p">You Can Also Find Us On:
              <a target="_blank" rel="noopener" aria-label="Productive Labs Facebook" itemprop="sameAs" href="https://www.facebook.com/productive.labs.il" title="our facebook page" class="social-btn">
                <img src="/img/saas/facebook.svg" alt="facebook" class="align-self-center w-100 social-img">
              </a>

            </p>
          </div>
          <div class="col-sm-12 col-md order-12">
            <form @submit.prevent="submit" data-aos="fade-up" data-aos-duration="1200">
              <div class="contact_input_area">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <input type="text"
                             class="form-control"
                             v-model="name"
                             aria-label="name"
                             name="name"
                             id="name"
                             placeholder="Full name"
                             required="">
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input type="email"
                             class="form-control"
                             name="email"
                             aria-label="email"
                             v-model="email"
                             id="email"
                             placeholder="Your best email"
                             @input="leadCatching"
                             required="">
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                                                <textarea name="message"
                                                          class="form-control"
                                                          id="message"
                                                          aria-label="message"
                                                          v-model="message"
                                                          cols="30"
                                                          rows="4"
                                                          placeholder="How can we help you?"
                                                          required=""></textarea>
                    </div>
                  </div>
                  <div class="col-12">
                    <button name="contact-us" type="submit" class="btn submit-btn secondary pull-right">
                      <span>{{ submitBtn }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: 'contact',
  data() {
    return {
      name: null,
      email: null,
      message: null,
      submitBtn: 'Let\'s Talk',
      loading: false,
    }
  },
  computed: {

  },
  methods: {
    leadCatching() {
      return _.endsWith(this.email, 'com') || _.endsWith(this.email, 'co.il')
          ? window.fbq('track', 'Lead', {content_name: this.email}) : null;
    },
    submit () {
      this.submitBtn = 'Sending...';
      this.loading = true;
      window.fbq('track', 'CompleteRegistration', {content_name: this.email});
      axios.post('/contact',{
        name: this.name,
        email: this.email,
        message: this.message,
      }).then((response) => {
        this.submitBtn = 'Let\'s Talk';
        this.loading = false;
        !response.data.error ? this.$swal({
          title: 'Thank You!',
          text: this.$i18n.t('We got your message, We will get back to you ASAP'),
          type: 'success',
          confirmButtonText: 'OK',
        }) : this.$swal({
          title: 'OOPS...',
          text: 'Connection problem, please try again later',
          type: 'error',
          confirmButtonText: 'OK',
        });
      }).catch((error) => {
        this.submitBtn = 'Let\'s Talk';
        this.loading = false;
        this.$swal({
          title: 'OOPS...',
          text: 'Connection problem, please try again later',
          type: 'error',
          confirmButtonText: 'OK',
        });
      });
    },
  },
}
</script>

<style lang="css" scoped>
.saas-contact-us {
  background-attachment: fixed;
  background-size: cover;
  padding-bottom: 120px;
  padding-top: 120px;
  color:#000000;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #ffffff;
}

.social-btn{
  text-align: center;
  display: inline-block;
  width: 35px;
  height: 35px;
  margin-left: 10px;
  border-radius: 50%;
  color: #fff;
}
.social-img{
  border: 2px #fff3cd solid;
  border-radius: 50%;
}
.social-btn:hover {
  box-shadow: 0px 0px 20px 0 rgba(255, 255, 255, 0.16);

}
.contact-title{
  margin-bottom: 35px;
  font-size: 45px;
}
.contact-p{
  font-size:  20px;
  margin-bottom: 60px;
}

.form-control {
  font-size: 18px;
  padding: 15px 15px;
  border-radius: 25px 25px 25px 25px;
  border: 1px solid #CBCBCB;
  background-color: transparent;
  color: #ffffff;
  direction: ltr;
  text-align: left;
}
button.secondary {
  height: 48px;
  min-width: 185px;
  color: #ffffff;
  font-weight: 500;
  border-radius: 22px 25px 22px 22px;
  cursor: pointer;
  background: linear-gradient(144deg, #00a5b7 10%, #00c092 65%);
  margin-top: 15px;
}
button.secondary:hover {
  color: #751da7;
}
</style>
